import React from 'react';
import { conceptColor } from '../../lib/citasApi';
import { SelectGroup, SelectItem, SelectLabel, SelectSeparator } from '../ui/select';

/**
 * Opciones de concepto agrupadas por categoría (Consultas / Cirugías) para
 * usar dentro de un <SelectContent>. Todas las citas funcionan igual: la
 * categoría solo organiza el desplegable.
 *
 * Props:
 *  - conceptos:  lista de conceptos activos
 *  - minutesFor: (concepto) => minutos a mostrar (permite aplicar overrides
 *                de la agenda); si no se pasa, usa default_minutes.
 */
export default function ConceptoOptions({ conceptos = [], minutesFor }) {
  const minutes = minutesFor || ((c) => c.default_minutes);
  const consultas = conceptos.filter((c) => (c.category || 'consulta') !== 'cirugia');
  const cirugias = conceptos.filter((c) => (c.category || 'consulta') === 'cirugia');

  const renderItem = (c) => (
    <SelectItem key={c.code} value={c.code}>
      <span className="inline-flex items-center gap-2">
        <span
          className="w-2.5 h-2.5 rounded-full shrink-0"
          style={{ backgroundColor: conceptColor(c) }}
          aria-hidden="true"
        />
        {c.name} · {minutes(c)} min
      </span>
    </SelectItem>
  );

  if (cirugias.length === 0) return <>{consultas.map(renderItem)}</>;

  return (
    <>
      <SelectGroup>
        <SelectLabel>Consultas</SelectLabel>
        {consultas.map(renderItem)}
      </SelectGroup>
      <SelectSeparator />
      <SelectGroup>
        <SelectLabel>Cirugías</SelectLabel>
        {cirugias.map(renderItem)}
      </SelectGroup>
    </>
  );
}
